import React, { useState } from "react";
import { Provider } from "react-redux";
import { createContext } from "react";
import { BrowserRouter } from "react-router-dom";
import { ThemeSwitcherProvider } from "react-css-theme-switcher";
import store from "./store";
import history from "./history";
import Layouts from "./layouts";
import { THEME_CONFIG } from "./configs/AppConfig";
import "./lang";
// import mockServer from './mock'

const themes = {
  dark: `${process.env.PUBLIC_URL}/css/dark-theme.css`,
  light: `${process.env.PUBLIC_URL}/css/light-theme.css`,
};

// const environment = process.env.NODE_ENV

// if (environment !== 'production') {
// 	mockServer({ environment })
// }
export const authContext = createContext();

function App() {
  localStorage.setItem("token", "");
  const [token, setToken] = useState(false);

  const updateToken = (val) => {
    setToken(val);
  };

  return (
    <authContext.Provider value={{ token, updateToken }}>
      <div className="App">
        <Provider store={store}>
          <BrowserRouter history={history}>
            <ThemeSwitcherProvider
              themeMap={themes}
              defaultTheme={THEME_CONFIG.currentTheme}
              insertionPoint="styles-insertion-point"
            >
              <Layouts />
            </ThemeSwitcherProvider>
          </BrowserRouter>
        </Provider>
      </div>
    </authContext.Provider>
  );
}

export default App;
